import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/SysUser/Role/';

const state = {};

const mutations = {};

const actions = {

  Get({commit}, view) {
    return request.PromiseCall(basePath, 'Get', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/SysUser/Role/index.js